import { useMemo } from "react";
import {
  listStarterTemplates,
  type VerticalStarterPage,
  type VerticalStarterTemplate,
} from "@ease/page-builder";

type PickOneSource = "builder-shell" | "sites" | "onboarding";

interface PickOneRouteOptions {
  siteId?: string | null;
  source?: PickOneSource;
}

interface PickOneStarterRouteOptions extends PickOneRouteOptions {
  starterPageId?: string;
}

export function getPickOneTemplates(): VerticalStarterTemplate[] {
  return listStarterTemplates();
}

export function buildPickOneEntryHref(options: PickOneRouteOptions = {}) {
  const searchParams = new URLSearchParams({ mode: "pick-one" });

  if (options.siteId) {
    searchParams.set("siteId", options.siteId);
  }

  if (options.source) {
    searchParams.set("source", options.source);
  }

  return `/pages/new?${searchParams.toString()}`;
}

export function buildPickOneStarterHref(
  vertical: string,
  options: PickOneStarterRouteOptions = {},
) {
  const searchParams = new URLSearchParams({ template: vertical });

  if (options.starterPageId) {
    searchParams.set("starter", options.starterPageId);
  }

  if (options.siteId) {
    searchParams.set("siteId", options.siteId);
  }

  if (options.source) {
    searchParams.set("source", options.source);
  }

  return `/pages/ai-generate?${searchParams.toString()}`;
}

export function getDefaultStarterPage(
  template: VerticalStarterTemplate,
): VerticalStarterPage | undefined {
  return template.pages[0];
}

export function usePickOneTemplates() {
  return useMemo(() => getPickOneTemplates(), []);
}
